module.exports = __webpack_public_path__ + "media/images/athletes/1850-9222b7bfe0bbd6a308aa826326b7964a.png";